export const flags = {
    "showModuleHeader" : false
}